import React from 'react';
import { IonPage, IonContent } from '@ionic/react';
import FeatureMobileHeader from '../../components/FeatureMobileHeader';

const Section: React.FC<{ title: string; plain: string; children?: React.ReactNode }> = ({ title, plain, children }) => (
  <>
    <h3 style={{ fontSize: 13, fontFamily: 'var(--fhv2-mono)', letterSpacing: '1.5px', textTransform: 'uppercase', color: 'var(--fhv2-terra)', margin: '28px 0 12px' }}>{title}</h3>
    <div style={{ background: 'rgba(72,101,63,0.1)', border: '1px solid rgba(72,101,63,0.3)', borderRadius: 12, padding: '14px 16px', marginBottom: 14 }}>
      <div style={{ fontFamily: 'var(--fhv2-mono)', fontSize: 10, letterSpacing: '1.5px', color: 'var(--fhv2-forest-light)', textTransform: 'uppercase', marginBottom: 6 }}>
        IN PLAIN ENGLISH
      </div>
      <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55, color: '#fff' }}>{plain}</p>
    </div>
    {children}
  </>
);

const TermsOfServicePage: React.FC = () => (
  <IonPage>
    <IonContent>
      <div className="fhv2-mpage fh-pb-safe" style={{ fontFamily: 'var(--fhv2-sans)' }}>
        <FeatureMobileHeader title="Terms" />
        <div className="fhv2-mlead2">
          Legal, <em>plainly.</em>
          <span className="sub">Updated 22 April 2026 · v2.5</span>
        </div>

        <Section title="§1 · The deal" plain="You pay us a subscription, we give you the app. You can cancel any time, takes two taps.">
          <p style={{ fontSize: 13, lineHeight: 1.7, color: 'var(--fhv2-muted)', margin: '0 0 14px' }}>
            Joro Services Ltd (company number 14079588, registered in England and Wales) provides the FamHearth application under these terms.
          </p>
        </Section>

        <Section title="§2 · Your content" plain="It's yours. We store it, encrypted. We never look at it. You can export or delete it whenever you like.">
          <p style={{ fontSize: 13, lineHeight: 1.7, color: 'var(--fhv2-muted)', margin: '0 0 14px' }}>
            You grant us a non-exclusive licence to process your content solely for the purpose of operating the service.
          </p>
        </Section>

        <Section title="§3 · Cancellation" plain="Settings → Subscription → Cancel. You'll keep access until the end of your billing period. No &lsquo;are you sure&rsquo; loops.">
          <p style={{ fontSize: 13, lineHeight: 1.7, color: 'var(--fhv2-muted)', margin: '0 0 14px' }}>
            All payments are non-refundable except where required by consumer law. Monthly plans cancel at the end of the current period; annual plans pro-rate.
          </p>
        </Section>

        <Section title="§4 · Disputes" plain="Chat first (hello@famhearth.com). If we can't sort it, English law, London courts.">
          <p style={{ fontSize: 13, lineHeight: 1.7, color: 'var(--fhv2-muted)', margin: '0 0 14px' }}>
            These terms are governed by the laws of England and Wales. Consumer users retain their statutory rights.
          </p>
        </Section>

        <div style={{ height: 40 }} />
      </div>
    </IonContent>
  </IonPage>
);

export default TermsOfServicePage;
